// extracted by mini-css-extract-plugin
export default {"wrapper":"whitelist_wrapper__BU4E4","items":"whitelist_items__aThgO","item":"whitelist_item__Bmbm8","deleteConfirmationModalFooter":"whitelist_deleteConfirmationModalFooter__5QtmY"};